import script from "./RecCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./RecCalendar.vue?vue&type=style&index=0&id=0bde42aa&lang=scss"

const __exports__ = script;

export default __exports__